import { render, staticRenderFns } from "./ArchiveDelete.vue?vue&type=template&id=be976074&"
import script from "./ArchiveDelete.vue?vue&type=script&lang=js&"
export * from "./ArchiveDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports